<template>
  <v-container fluid class="py-2">
    <v-row>
      <v-col cols="12" md="10" offset-md="1" v-if="recentActivity.length > 0">
        <v-timeline align-top dense>
          <v-timeline-item
            v-for="(row, i) in recentActivity"
            :key="i"
            color="green"
            small
          >
            <v-card outlined class="rounded-lg shadow-sm border mb-3">
              <v-card-text class="p-4 text-dark-75">
                <div
                  class="d-flex align-items-center justify-content-between pb-2 border-bottom mb-2"
                >
                  <div class="d-flex align-items-center">
                    <v-icon small color="cyan darken-1" class="mr-2"
                      >mdi-history</v-icon
                    >
                    <strong class="font-size-15 color-custom-blue"
                      >Activity Log</strong
                    >
                  </div>
                  <v-chip
                    small
                    color="cyan lighten-5"
                    class="cyan--text text--darken-2 font-weight-600 px-3"
                  >
                    <v-icon small left color="cyan darken-1"
                      >mdi-clock-outline</v-icon
                    >
                    {{ row.created_at }}
                  </v-chip>
                </div>
                <div class="font-size-13 font-weight-500 pt-1">
                  <read-more
                    class="custom-read-more font-size-13 font-weight-500 line-height-1-4"
                    more-str="read more"
                    :text="row.description ? row.description : ''"
                    link="#"
                    less-str="read less"
                    :max-chars="120"
                  >
                  </read-more>
                </div>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </v-col>

      <v-col cols="12" class="py-8 text-center" v-else>
        <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
          <template v-if="pageLoading">
            <span class="py-8 d-block">Getting recent activities...</span>
            <v-progress-linear
              color="cyan"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </template>
          <template v-else>
            <img
              :src="$assetURL('media/error/empty.png')"
              class="row-not-found-image mb-2"
            />
            <br />
            Uhh... There are no recent activities at the moment.
          </template>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { GET } from "@/core/services/store/request.module";
import CommonMixin from "@/core/plugins/common-mixin";
export default {
  mixins: [CommonMixin],
  name: "recent-activity",
  props: {
    user: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      pageLoading: true,
      recentActivity: [],
    };
  },
  methods: {
    getUserActivity() {
      const _this = this;
      return new Promise((resolve, reject) => {
        try {
          _this.$store
            .dispatch(GET, { url: "user/" + _this.user + "/recent-activity" })
            .then((response) => {
              resolve(response.data);
            })
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  mounted() {
    const _this = this;
    _this
      .getUserActivity()
      .then((response) => {
        _this.recentActivity = response;
      })
      .catch((error) => {
        _this.logError(error);
      })
      .finally(() => {
        _this.pageLoading = false;
      });
  },
};
</script>
<style scoped>
::v-deep .v-timeline-item__opposite {
  white-space: nowrap;
  min-width: 120px;
}
</style>
